import { calendar } from '@microsoft/teams-js'
import useTeamsEnabledModule from '../useIsMsTeams/useTeamsEnabledModule'

export const useCalendarEnabled = () => useTeamsEnabledModule(calendar)

export default useCalendarEnabled
